/** The Meetings & summaries sub-tab in the URL (`mt`; TMMAPP-0108). */
import { enumParam } from '@/shared/useUrlState';

export const MEETING_TABS = ['upcoming', 'past', 'calendar'] as const;

export type MeetingTab = (typeof MEETING_TABS)[number];

export const MEETINGS_URL = { mt: enumParam<MeetingTab>(MEETING_TABS, 'upcoming') };
